import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c66d283a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = { class: "row gx-8" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "row"
}
const _hoisted_6 = {
  key: 0,
  class: "navigation__badge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_badge = _resolveComponent("app-badge")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.useAsSelect)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigationData, (nav) => {
              return (_openBlock(), _createElementBlock("div", {
                key: nav.activePage,
                class: _normalizeClass(["col", { 'selected': _ctx.selectedTab === nav.routeTo }]),
                onClick: _withModifiers(($event: any) => (_ctx.$emit('on-select', nav.routeTo)), ["prevent"])
              }, _toDisplayString(_ctx.$localize(nav.label)), 11, _hoisted_4))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigationData, (nav) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: nav.activePage,
                class: _normalizeClass(["col", { 'selected': _ctx.selectedPage === nav.activePage }]),
                to: nav.routeTo
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize(nav.label)) + " ", 1),
                  (nav.badges)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_app_badge, {
                          number: nav.badges
                        }, null, 8, ["number"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["class", "to"]))
            }), 128))
          ]))
    ])
  ]))
}